import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ConsolidationExportUIHelpers";

const ConsolidationExportUIContext = createContext();

export function useConsolidationExportUIContext() {
  return useContext(ConsolidationExportUIContext);
}

export const ConsolidationExportUIConsumer =
  ConsolidationExportUIContext.Consumer;

export function ConsolidationExportUIProvider({
  ConsolidationExportUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initConsolidationExport = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initConsolidationExport,
    newConsolidationExportButtonClick:
      ConsolidationExportUIEvents.newConsolidationExportButtonClick,
    openEditConsolidationExportPage:
      ConsolidationExportUIEvents.openEditConsolidationExportPage,
    openConsolidationExportFilePage:
      ConsolidationExportUIEvents.openConsolidationExportFilePage
  };

  return (
    <ConsolidationExportUIContext.Provider value={value}>
      {children}
    </ConsolidationExportUIContext.Provider>
  );
}
